<template>
  <section id="serwis" class="services section">
    <!-- Adding oferta as secondary ID -->
    <div id="oferta"></div>
    <div class="container">
      <div class="section-header" data-aos="fade-up">
        <h2>Nasza Oferta</h2>
        <div class="section-line"></div>
        <p>Oferujemy kompleksowe usługi serwisowe dla urządzeń Viessmann</p>
      </div>
      
      <div class="services-grid">
        <div class="service-card" data-aos="fade-up" data-aos-delay="100">
          <div class="service-icon">🏭</div>
          <h3>Konserwacje gwarancyjne i pogwarancyjne</h3>
          <p>Serwis i naprawa kotłów przemysłowych o dużej mocy</p>
          <ul class="service-features">
            <li>Przeglądy techniczne</li>
            <li>Naprawy awaryjne</li>
            <li>Modernizacja systemów</li>
          </ul>
        </div>
        
        <div class="service-card" data-aos="fade-up" data-aos-delay="200">
          <div class="service-icon">🔥</div>
          <h3>Diagnoza i naprawa</h3>
          <p>Profesjonalny serwis kotłów średniej mocy</p>
          <ul class="service-features">
            <li>Instalacja i uruchomienie</li>
            <li>Serwis gwarancyjny</li>
            <li>Konserwacja prewencyjna</li>
          </ul>
        </div>
        
        <div class="service-card" data-aos="fade-up" data-aos-delay="300">
          <div class="service-icon">⚡</div>
          <h3>Umowy serwisowe</h3>
          <p>Specjalistyczny serwis kotłów Vitodens 200</p>
          <ul class="service-features">
            <li>Diagnostyka elektroniczna</li>
            <li>Wymiana podzespołów</li>
            <li>Optymalizacja pracy</li>
          </ul>
        </div>
        
        <div class="service-card" data-aos="fade-up" data-aos-delay="400">
          <div class="service-icon">🔗</div>
          <h3>Pierwsze uruchomienia</h3>
          <p>Instalacja i serwis systemów kaskadowych</p>
          <ul class="service-features">
            <li>Projektowanie kaskad</li>
            <li>Montaż systemów</li>
            <li>Programowanie sterowników</li>
          </ul>
        </div>
        
        <div class="service-card" data-aos="fade-up" data-aos-delay="500">
          <div class="service-icon">🏠</div>
          <h3>Ekspertyzy</h3>
          <p>Serwis kotłów małej mocy dla domów</p>
          <ul class="service-features">
            <li>Montaż w domach</li>
            <li>Przeglądy roczne</li>
            <li>Naprawy gwarancyjne</li>
          </ul>
        </div>
        
        <div class="service-card" data-aos="fade-up" data-aos-delay="600">
          <div class="service-icon">🔧</div>
          <h3>Czyszczenie chemiczne instalacji i urządzeń grzewczych</h3>
          <p>Naprawa i konserwacja kotłów Vitopend</p>
          <ul class="service-features">
            <li>Serwis kotłów wiszących</li>
            <li>Wymiana części</li>
            <li>Regulacja parametrów</li>
          </ul>
        </div>
      </div>
      
      <div class="service-cta" data-aos="fade-up" data-aos-delay="700">
        <h3>Potrzebujesz pomocy?</h3>
        
        <router-link :to="{ name: 'Contact' }" class="btn">Skontaktuj się</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection'
}
</script>

<style lang="scss" scoped>
.services {
  background: white;
}

#oferta {
  position: absolute;
  top: -80px; // Offset for navbar
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto 20px;
    border-radius: 2px;
  }
  
  p {
    font-size: 1.1rem;
    color: #666;
  }
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.service-card {
  background: white;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(255, 107, 53, 0.15);
  }
  
  .service-icon {
    font-size: 3rem;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  p {
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
  }
  
  .service-features {
    list-style: none;
    padding: 0;
    text-align: left;
    
    li {
      color: #555;
      margin-bottom: 8px;
      padding-left: 20px;
      position: relative;
      
      &:before {
        content: '✓';
        position: absolute;
        left: 0;
        color: #FF6B35;
        font-weight: bold;
      }
    }
  }
}

.service-cta {
  text-align: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 60px 40px;
  border-radius: 20px;
  
  h3 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  p {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .service-cta {
    padding: 40px 20px;
    
    h3 {
      font-size: 1.5rem;
    }
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>